import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

const EditLeagueWeekModal = ({ isOpen, toggle, onSave, week, leagueId }) => {
  const [editedWeek, setEditedWeek] = useState({
    league: leagueId,
    week: '',
    par: '',
    notes: ''
  });

  useEffect(() => {
    if (week) {
      setEditedWeek({
        league: week.league || leagueId,
        week: week.week || '',
        par: week.par ?? '',
        notes: week.notes || ''
      });
    }
  }, [week, leagueId]);

  const handleSave = () => {
    onSave({
      ...editedWeek,
      par: editedWeek.par === '' ? null : Number(editedWeek.par),
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedWeek(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Week</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="week">Week Number *</Label>
          <Input
            type="number"
            id="week"
            name="week"
            value={editedWeek.week}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="par">Par</Label>
          <Input
            type="number"
            id="par"
            name="par"
            value={editedWeek.par}
            onChange={handleChange}
            placeholder="Optional par value"
            min="0"
          />
        </FormGroup>
        <FormGroup>
          <Label for="notes">Notes</Label>
          <Input
            type="textarea"
            id="notes"
            name="notes"
            value={editedWeek.notes}
            onChange={handleChange}
            placeholder="Optional notes for this week"
            rows="3"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!editedWeek.week}>
          Save Changes
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditLeagueWeekModal;
